enum ApplicationType {
  Sandbox = 'Sandbox',
  Production = 'Production',
}

export { ApplicationType };
